import React from "react";
import Colors from "../../constants/Colors";
import styled from "styled-components";
import {deviceMax} from "../../../styles/device";
import Link from "next/link";
import { NavigationURLs } from "../../functions/NavigationFunctions";

const CustomerService = () => {
    return (
        <CustomerServiceWrapper id={'customer-service'}>
            <div className="customer-service-container">
                <div className="bg-img"></div>
                <div className="customer-service-wrapper">
                    <h2>
                        Müşteri Hizmetleri
                    </h2>
                    <p>
                        Sorularınız için <Link href={'mailto:bilgi@pembepanjur.com'}>bilgi@pembepanjur.com</Link> ‘a
                        mail atabilirsiniz. Ayrıca <Link href={'tel:0850 558 08 08'}>"0850 558 08 08"</Link> numaralı
                        hattımızdan 09:00 – 01:00 arasında müşteri hizmetleri yetkililerimizle iletişime
                        geçebilirsiniz.
                    </p>
                    <p>
                        <Link href={NavigationURLs.support}>
                            Yardım
                        </Link> sayfamızı ziyaret edin.
                    </p>
                </div>
            </div>
        </CustomerServiceWrapper>
    )
}

const CustomerServiceWrapper = styled.div`
  position: relative;
  min-height: 485px;
  margin-top: 26px;
  margin-right: 20px;
  margin-left: 20px;

  @media ${deviceMax.tablet} {
    margin-top: 0;
  }

  > .customer-service-container {
    position: relative;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    > .bg-img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('/next/assets/images/customer-service/customer-service.png') no-repeat center center;
      background-size: cover;
      min-height: 485px;

      @media ${deviceMax.tablet} {
        position: relative;
        min-height: 212px;
      }
    }

    > .customer-service-wrapper {
      position: relative;
      padding: 23px 0 23px 56px;
      width: 100%;
      max-width: 380px;

      @media ${deviceMax.tablet} {
        padding-left: 34px;
        padding-right: 34px;
        max-width: fit-content;
        background-color: ${Colors.white};
      }

      > h2 {
        font-family: 'Manrope', sans-serif;
        font-weight: 800;
        font-size: 18px;
        line-height: 55px;
        letter-spacing: 0;
        text-transform: uppercase;
        color: ${Colors.brandColor};

        @media ${deviceMax.tablet} {
          color: ${Colors.blackColor};
          text-align: center;
          margin: 0 auto 16px;
        }
      }

      > p {
        font-family: 'Manrope', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 0;
        color: ${Colors.blackColor};

        @media ${deviceMax.tablet} {
          text-align: center;
          margin: 17px auto;
        }

        > a {
          font-weight: 800;
          color: ${Colors.blackColor};
          transition: all 0.3s ease-in-out;

          &:hover {
            color: ${Colors.brandColor};
          }
        }
      }
    }
  }
`;

export default CustomerService;
